module.exports = __webpack_public_path__ + "img/the-field-gal-7.6fc85f64.jpg";